import { useMutation } from '@tanstack/react-query';
import { ambientApi } from 'src/services';
import { showToastSuccess } from 'src/utilities/toast';
import { showToastError } from 'src/utilities/errortoast';

interface UseSubmitMedicationOrdersPayload {
  encounterId: string;
  medication_orders: any[];
}

export const useSubmitMedicationOrders = () => {
  return useMutation({
    mutationKey: ['submitMedicationOrders'],
    mutationFn: (payload: UseSubmitMedicationOrdersPayload) =>
      ambientApi
        .post(`/ehr/orders/medication`, {
          encounter_id: payload.encounterId,
          medication_orders: payload.medication_orders,
        })
        .then((res) => res.data),
    onSuccess: () => {
      showToastSuccess('Medication orders submitted to EHR successfully');
    },
    onError: (error: any) => {
      showToastError(
        error?.response?.data?.message ||
          'Failed to submit medication orders to EHR'
      );
    },
  });
};
